import * as endpoints from '@App/constants/endpoints';
import interceptor    from '../interceptor';
import axiosRef       from 'axios';
import * as util from "@Util";
import { get }        from '../util';
import { post }       from '../util';
import { put }        from '../util';

const ANSWERS      = 'answers';
const FORM         = 'form';
const MODEL        = 'model';
const VERSION      = 'version';
const EMPTY        = 'empty';
const DRAFT        = 'draft';
const NAME         = 'name';
const AVAILABILITY = 'availability';
const ACCOUNT      = 'account';
const PRINT_FORMAT = 'printFormat';
const MANAGER      = 'manager';
const MANY         = 'many';
const PERMISSION   = 'permission';
const AUTHOR       = 'author';

//#region GET
export const getFormModels = async ({header}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${MANAGER}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormAnswers = async ({header, formModelId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${formModelId}/${ANSWERS}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormModelVersionById = async ({header, formModelVersionId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${VERSION}/${MANAGER}/${formModelVersionId}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormById = async ({header, formId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${formId}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormPrintFormat = async ({header, formId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${formId}/${PRINT_FORMAT}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormModelByIdAnswer = async ({header, formModelId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${formModelId}/${ANSWERS}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormListAnswers = async ({header}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDrafts = async ({header, isAccountForm = 0}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${MODEL}/${MANAGER}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDraftsRequestProm = async ({header}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/requestProm/${MODEL}/${MANAGER}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDraftById = async ({header, draftId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${MANAGER}/${draftId}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const checkNameFormModel = async ({header, nameForm}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${NAME}/${AVAILABILITY}/${MANAGER}/${nameForm}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};

export const checkNameAccountFormModel = async ({header, nameForm}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${NAME}/${ACCOUNT}/${AVAILABILITY}/${nameForm}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl);
};
//#endregion

//#region POST
export const createFormEmpty = async ({header, formModelVersionId}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${EMPTY}/${formModelVersionId}`;
  const axios   = interceptor(header);
  return await post(axios, pathUrl);
};

export const saveForm = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${MANAGER}`;
  const axios   = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const createAnsweredForm = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios   = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const postDraft = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${MANAGER}`;
  const axios   = interceptor(header);
  return await post(axios, pathUrl, params);
};
//#endregion
let updateAnsweredFormPreviousCall = null; // keeps the last call out of the updateAnsweredForm scope
//#region PUT
export const updateAnsweredForm = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios   = interceptor(header);
  const source = axiosRef.CancelToken.source();
  const config = {
    cancelRequest: source.cancel,
    cancelToken: source.token
  }
  if(updateAnsweredFormPreviousCall) updateAnsweredFormPreviousCall.cancel(); // cancels previous updateAnsweredForm reqs promises if they're not resolved
  updateAnsweredFormPreviousCall = source;

  return await put(axios, pathUrl, params, config);
};

export const putDraft = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${MANAGER}`;
  const axios   = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const putDraftMany = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${MANAGER}/${MANY}`;
  const axios   = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const putFormModelMany = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${PERMISSION}/${MANAGER}/${MANY}`;
  const axios   = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const putDraftManyAuthorsCategory = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${AUTHOR}/${MANAGER}/${MANY}`;
  const axios   = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const putFormModelManyAuthorsCategory = async ({header, params}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${AUTHOR}/${MANAGER}/${MANY}`;
  const axios   = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const uploadDocumentForExtraction = async ({ header, params, onUploadProgress }) => {
  const { file } = params;
  const formData = new FormData();
  formData.append('pdf', file);
  
  const pathUrl = `${endpoints.API_FORMS}/ai/proms/analyze-pdf/${MANAGER}`;
  const axios = interceptor({
    ...header,
    'Content-Type': 'multipart/form-data'
  });
  
  const config = {
    onUploadProgress: onUploadProgress || null
  };
  
  return await post(axios, pathUrl, formData, config);
};

export const extractTextFromDocument = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${EXTRACT}/${TEXT}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

/**
 * @param {string} jobId - ID do job
 * @param {object} header - Objeto com token, account, workspace, etc (mesmo formato do interceptor)
 * @param {function} onMessage - Callback para mensagens recebidas (recebe { event, data, timestamp })
 * @param {function} onError - Callback para erros
 * @param {function} onClose - Callback quando conexão for fechada
 * @returns {function} Função para fechar a conexão
 */
export const streamJobProgress = async ({ jobId, header, onMessage, onError, onClose }) => {
  const auth =  JSON.parse(localStorage.getItem('auth') || "{}");
  
  const wsUrl = endpoints.API_DOMAIN_WEBSOCKET;
  
  try {
    let token = auth?.token || header?.token || '';
    let account = header?.account || header?.accountId || '';
    let workspace = header?.workspace || header?.workspaceId || '';
    let userId = header?.userId || '';
    let formOrigin = header?.formOrigin || '';
    
    let lang = navigator.language || navigator.userLanguage;
    if (auth && auth.languageCode) {
      lang = auth.languageCode;
    }
    if (lang) {
      lang = lang.startsWith('pt') ? lang : lang.split('-')[0];
    }

    const params = new URLSearchParams();
    params.append('jobId', encodeURIComponent(jobId));
    if (token) params.append('token', encodeURIComponent(`Bearer ${token}`));
    if (account) params.append('account', encodeURIComponent(account));
    if (workspace) params.append('workspace', encodeURIComponent(workspace));
    if (userId) params.append('userId', encodeURIComponent(userId));
    if (formOrigin) params.append('formOrigin', encodeURIComponent(formOrigin));
    if (lang) params.append('lang', encodeURIComponent(lang));

    const url = `${wsUrl}/ws/jobs/${MANAGER}?${params.toString()}`;
    
    const ws = new WebSocket(url);

    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        
        if (message.event !== 'heartbeat') {
          onMessage(message);
        }
      } catch (error) {
        console.error('Erro ao parsear mensagem WebSocket:', error);
      }
    };

    ws.onerror = (error) => {
      if (onError) onError(error);
    };

    ws.onclose = () => {
      if (onClose) onClose();
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };

  } catch (error) {
    if (onError) onError(error);
    return () => {}; 
  }
};